export default __webpack_public_path__ + "static/media/Vector.23c76bcd.svg";